<template>
  <transition name="fade-up">
    <div v-if="parsedErrors.length > 0" :class="{ 'error--center': center }" class="error">
      <p class="error__content" v-html="errors"/>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    errors: {
      type: String,
      default: ''
    },
    center: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parsedErrors () {
      const errors = this.errors || ''
      return errors
    }
  }
}
</script>

<style lang="scss" scoped>
  .error {
    font-size: 12px;
    color: $error;
    position: relative;

    &--center &__content {
      padding-top: 8px;
      text-align: center;
    }

    &__content {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      transform: translateY(calc(100% + 2px));
      margin: 0;
    }

    .signature-box & {
      bottom: -40px;
    }
  }

  .fade-up-enter-active,
  .fade-up-leave-active {
    transition: opacity .3s,
    transform .3s;
  }

  .fade-up-enter {
    opacity: 0;
    transform: translate3d(0, 6px, 0);
  }

  .fade-up-leave-to {
    opacity: 0;
    transform: translate3d(0, -6px, 0);
  }
</style>
